const Home = () => import('@/views/jd/home') // 首页
const Search = () => import('@/views/jd/search') // 搜索
const Mine = () => import('@/views/jd/mine') // 我的

export default [
  { path: '/jd', name: 'jdHome', component: Home, meta: { isTab: false, keepAlive: true, title: '京东热卖' } },
  { path: '/jd/search', name: 'jdSearch', component: Search, meta: { isTab: false, keepAlive: true, title: '搜索' } },
  { path: '/jd/mine', name: 'jdMine', component: Mine, meta: { isTab: false, keepAlive: true, requireAuth: false, title: '我的' } },
]